import React, { useMemo } from 'react';

// Campo de estrellas puro CSS — sin canvas, sin librería
function StarField({ count = 180 }) {
  const stars = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      id: i,
      x:        (Math.random() * 100).toFixed(2),
      y:        (Math.random() * 100).toFixed(2),
      size:     (Math.random() * 1.8 + 0.3).toFixed(2),
      delay:    (Math.random() * 7).toFixed(2),
      duration: (Math.random() * 4 + 2).toFixed(2),
      opacity:  (Math.random() * 0.55 + 0.15).toFixed(2),
    })),
  [count]);

  return (
    <div style={{
      position:      'fixed',
      inset:         0,
      zIndex:        0,
      pointerEvents: 'none',
      overflow:      'hidden',
    }}>
      {stars.map(s => (
        <div
          key={s.id}
          style={{
            position:     'absolute',
            left:         `${s.x}%`,
            top:          `${s.y}%`,
            width:        `${s.size}px`,
            height:       `${s.size}px`,
            borderRadius: '50%',
            background:   '#ffffff',
            opacity:      s.opacity,
            animation:    `twinkle ${s.duration}s ${s.delay}s infinite alternate ease-in-out`,
          }}
        />
      ))}
    </div>
  );
}

export default StarField;
